import { defineComponent, ref, onMounted, nextTick } from "/Scripts/vue.esm-browser.js";
import { Swiper } from "/Scripts/swiper@11.2.6.js";

const html = String.raw;

export default defineComponent({
  name: "Announce",
  setup() {
    const anns = ref([]);
    const show = ref(false);
    const swiper = ref(null);
    const ANNStorage = "ANNStorage";

    const methods = {
      Open: (link) => {
        let href = link;
        if (href.indexOf("http") === -1) {
          //href = "https://" + href;
        }
        const win = window.open(href, "_blank");
        win.focus();
      },

      OpenANN: (idx) => {
        swiper.value.update();
        swiper.value.slideTo(idx, 0);
        show.value = true;
      },

      DateParse: (date) => {
        return (date || "")
          .split("T")
          .join(" ")
          .substring(0, 16)
          .replace(/-/g, "/");
      },

      GetANNStorage: (SN) => {
        return localStorage.getItem(ANNStorage + SN) === "true";
      },

      SetANNStorage: (SN) => {
        const Now = methods.GetANNStorage(SN);
        localStorage.setItem(ANNStorage + SN, !Now);
      },

      SetSwiper: () => {
        if (!swiper.value) {
          swiper.value = new Swiper(
            "#app-ann .notice-wrapper .swiper-container",
            {
              navigation: {
                nextEl: ".ann-swiper-button-next",
                prevEl: ".ann-swiper-button-prev",
              },
            }
          );
        }
      },
    };

    onMounted(() => {
      const url = new URL(window.location.href);
      const isANN = url.searchParams.get("ann");
      const APIUrl = isANN ? "ncapi.bwt.today" : "ncapi.bwt.com.tw";

      fetch("https://" + APIUrl + "/api/ann/getannouncement")
        .then((res) => res.json())
        .then((data) => {
          anns.value = data;
          if (anns.value.length) {
            document.querySelector(".header_b2c").classList.add("banner-ann");
          }
          let index = -1;
          anns.value.forEach((ann, idx) => {
            if (
              ann.ShowType === 1 &&
              !methods.GetANNStorage(ann.AnnouncementSN)
            ) {
              methods.SetSwiper();
              index = idx;
            }
          });
          if (index > -1) {
            setTimeout(() => {
              methods.OpenANN(index);
            }, 1000);
          }
        })
        .catch((error) => {
          console.error("獲取公告資料失敗:", error);
        });

      nextTick(() => {
        setTimeout(() => {
          if (anns.value.length) {
            methods.SetSwiper();
          }
        }, 1000);
      });
    });

    return {
      anns,
      show,
      ...methods,
    };
  },
  template: html`
    <div id="app-ann" v-cloak>
      <div v-if="anns.length" class="notice-banner">
        <div class="notice-banner-tag" style="display:none">緊急公告</div>
        <div class="notice-banner-item-wrapper">
          <div v-for="(ann,idx) in anns" class="notice-banner-item">
            <a v-on:click="OpenANN(idx)">{{ann.BannerTitle}}</a>
          </div>
        </div>
      </div>
      <div class="notice-wrapper" :class="{hide:!show}">
        <div class="notice-black"></div>
        <div class="swiper-container">
          <div class="swiper-wrapper" v-if="anns.length">
            <div class="swiper-slide" v-for="ann in anns">
              <div class="notice">
                <div class="notice-close note_Close_button_x">
                  <a href="javascript:void(0)" v-on:click="show=false"></a>
                </div>
                <div class="notice-content">
                  <template v-if="ann.AnnouncementType===2">
                    <img :src="ann.IMG" v-on:click="Open(ann.IMGLink)" alt="" />
                  </template>
                  <template v-else>
                    <p class="title" :class="'word-color'+ann.ContentColor">
                      {{ann.ContentTitle}}
                    </p>
                    <p v-html="ann.ContentInfo"></p>
                    <ul>
                      <li v-if="memo.ContentInfo" v-for="memo in ann.Memos">
                        {{memo.ContentInfo}}
                      </li>
                    </ul>
                    <button
                      v-if="link.LinkTitle"
                      class="link"
                      v-for="link in ann.Links"
                      v-on:click="Open(link.Link)"
                      :class="'bg-color'+link.LinkBGColor+' word-color'+link.LinkColor"
                    >
                      {{link.LinkTitle}}
                    </button>
                    <p class="update-time">
                      {{DateParse(ann.ModifyDate)}} 更新
                    </p>
                  </template>
                </div>
                <div class="notice-check" v-if="ann.ShowType===1">
                  <input
                    type="checkbox"
                    :id="'chk'+ann.AnnouncementSN"
                    :checked="GetANNStorage(ann.AnnouncementSN)"
                    v-on:click="SetANNStorage(ann.AnnouncementSN)"
                  />
                  <label :for="'chk'+ann.AnnouncementSN">不再顯示此公告</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: `
    .notice-wrapper {
      height: 6000px;
    }

    /* index notice */
    .header_b2c.banner-ann {
      margin-bottom: 62px;
    }

    #app-ann > .notice-banner {
      position: relative;
      top: 0px;
      display: flex;
      justify-content: center;
      background-color: #DE5757;
      width: 100%;
      max-width: 1250px;
      height: 32px;
      margin: 0 auto 0px;
    }

    #app-ann > .notice-banner .notice-banner-tag {
      margin: 6px 15px 6px 0;
      padding: 0 3px;
      font-size: 12px;
      color: #fff;
      border: 1px solid;
      cursor: default;
    }

    #app-ann > .notice-banner .notice-banner-item-wrapper {
      display: flex;
      counter-reset: step-counter;
    }

    #app-ann > .notice-banner .notice-banner-item {
      color: #fff;
      counter-increment: step-counter;
      position: relative;
    }

    #app-ann > .notice-banner .notice-banner-item:not(:only-child):before {
      position: absolute;
      top: 10px;
      left: 8px;
      content: counter(step-counter) ".";
      display: block;
      font-size: 12px;
      pointer-events: none;
    }

    #app-ann > .notice-banner .notice-banner-item a {
      display: block;
      height: 100%;
      padding: 0 15px 0 20px;
      color: #fff;
      font-size: 14px;
      line-height: 32px;
      cursor: pointer;
    }

    .destination_SN #app-ann {
      position: fixed;
      width: 100%;
      top: 98px;
      z-index: 101;
    }

    .destination_SN #app-ann > .notice-banner {
      max-width: none;
      top: 0;
      padding: 0 25px;
    }

    .type #app-ann .notice-banner {
      max-width: 100%;
    }

    /* notice-pop */
    .notice-black {
      position: fixed;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      overflow-y: auto;
      z-index: 888;
    }

    .notice-wrapper {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    .notice-wrapper .swiper-container {
      width: 950px;
      z-index: 889;
    }

    .notice-wrapper .swiper-wrapper {
    }

    .notice-wrapper .notice {
      top: 200px;
      display: block;
      background-color: #fff;
      width: 850px;
      height: auto;
      margin: 0 auto;
      padding: 70px 100px 0px;
      color: #333;
      font-size: 15px;
      text-align: justify;
      line-height: 25px;
      letter-spacing: 1.5px;
      box-sizing: border-box;
      box-shadow: 4px 4px 3px rgba(20%, 20%, 40%, 0.5);
      border-radius: 10px;
      z-index: 999;
    }

    .notice-content {
    }

    .notice-content .title {
      padding-bottom: 25px;
      color: #F17E1A;
      font-size: 25px;
      font-weight: bold;
      text-align: center;
    }

    .notice-content p, .notice-content li, .notice-content ul {
      margin: 0 5%;
      color: #707070;
      font-size: 15px;
      line-height: 1.6;
      letter-spacing: 1.1px;
      white-space: initial;
    }

    .notice-content li {
      margin-left: 21px;
      list-style: decimal;
    }

    .notice-content button.link {
      display: block;
      background-color: #F17E1A;
      margin: 20px auto 0;
      min-width: 160px;
      padding: 5px 20px;
      color: white;
      font-size: 14px;
      font-weight: bold;
      border-style: none;
      border-radius: 14px;
      cursor: pointer;
    }

    .notice-content p.update-time {
      margin: 20px 0;
      color: #707070;
      font-size: 12px;
      float: right;
    }

    .notice-content img {
      width: 100%;
      margin-bottom: 45px;
    }

    .notice-check {
      box-shadow: 0 -.5px 0 rgba(0, 0, 0, .2);
      text-align: center;
      padding: 8px 0;
    }

    .notice-check input {
      position: absolute;
      opacity: 0;
    }

    .notice-check label {
      position: relative;
      padding-left: 24px;
      color: #545454;
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 1px;
    }

    .notice-check label:after {
      position: absolute;
      top: 0px;
      left: 2px;
      content: '';
      display: inline-block;
      background-color: #d8d8d8;
      width: 16px;
      height: 16px;
      border-radius: 2px;
      transition: all, 0.1s;
    }

    .notice-check input[type="checkbox"]:checked + label:after {
      left: 6px;
      background: none;
      width: 6px;
      height: 10px;
      border: none;
      border-right: 3px solid #7fcae5;
      border-bottom: 3px solid #7fcae5;
      transform: rotate(45deg);
    }

    .notice-content:after {
      display: block;
      content: '';
      clear: both;
    }

    .notice-wrapper .ann-swiper-button-next, .notice-wrapper .ann-swiper-button-prev {
      top: 200px;
      background-size: 28px 54px;
      width: 28px;
      height: 54px;
    }

    .notice-wrapper .ann-swiper-button-next {
      background-image: url(/Content/Img/Public/swiper/swiper-next.ann.png);
    }

    .notice-wrapper .ann-swiper-button-prev {
      background-image: url(/Content/Img/Public/swiper/swiper-prev.ann.png);
    }

    .notice-close {
      position: absolute;
      top: 17px;
      right: 65px;
      background-color: transparent;
      width: 22px;
      height: 22px;
      float: none;
    }

    .notice-close a {
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
    }

    .notice-close a:before, .notice-close a:after {
      position: absolute;
      top: 9px;
      left: 0;
      content: '';
      display: block;
      background-color: #5D5D5D;
      width: 100%;
      height: 2px;
      border-radius: 30px;
      transform: rotate(45deg);
    }

    .notice-close a:before {
      transform: rotate(45deg);
    }

    .notice-close a:after {
      transform: rotate(-45deg);
    }

    /* color 配色設定 */
    .bg-color0 { background-color: #FFf !important; border: 1px solid gray !important; }
    .bg-color1 { background-color: #FF9800 !important; }
    .bg-color2 { background-color: #FF6E40 !important; }
    .bg-color3 { background-color: #F4511E !important; }
    .bg-color4 { background-color: #FF5252 !important; }
    .bg-color5 { background-color: #DE5757 !important; }
    .bg-color6 { background-color: #E57373 !important; }
    .bg-color7 { background-color: #D4E157 !important; }
    .bg-color8 { background-color: #338D42 !important; }
    .bg-color9 { background-color: #9CCC65 !important; }
    .bg-color10 { background-color: #BCAAA4 !important; }
    .bg-color11 { background-color: #A1887F !important; }
    .bg-color12 { background-color: #A67C52 !important; }
    .bg-color13 { background-color: #8C9EFF !important; }
    .bg-color14 { background-color: #90CAF9 !important; }
    .bg-color15 { background-color: #64B5F6 !important; }
    .bg-color16 { background-color: #0E67A1 !important; }
    .bg-color17 { background-color: #9575CD !important; }
    .bg-color18 { background-color: #fff !important; border: 1px solid gray !important; }

    .word-color0 { color: #FFf !important; }
    .word-color1 { color: #FF9800 !important; }
    .word-color2 { color: #FF6E40 !important; }
    .word-color3 { color: #F4511E !important; }
    .word-color4 { color: #FF5252 !important; }
    .word-color5 { color: #DE5757 !important; }
    .word-color6 { color: #E57373 !important; }
    .word-color7 { color: #D4E157 !important; }
    .word-color8 { color: #338D42 !important; }
    .word-color9 { color: #9CCC65 !important; }
    .word-color10 { color: #BCAAA4 !important; }
    .word-color11 { color: #A1887F !important; }
    .word-color12 { color: #A67C52 !important; }
    .word-color13 { color: #8C9EFF !important; }
    .word-color14 { color: #90CAF9 !important; }
    .word-color15 { color: #64B5F6 !important; }
    .word-color16 { color: #0E67A1 !important; }
    .word-color17 { color: #9575CD !important; }
    .word-color18 { color: #fff !important; }

    /* rwd */
    @media screen and (max-width: 1750px) {
      #app-ann > .notice-banner {
        /*top: 52px;
        margin-bottom: 30px;*/
      }
    }

    @media screen and (max-width:950px) {
      .notice-wrapper .swiper-container {
        width: 100%;
      }

      .notice {
        width: 90%;
        padding: 45px 30px 0;
      }
    }

    @media screen and (max-width: 930px) {
      #app-ann > .notice-banner {
        top: auto;
      }
    }

    @media screen and (max-width:768px) {
      .notice {
        padding: 45px 0 0;
      }

      .notice-content .title {
        padding-bottom: 15px;
        font-size: 17px;
      }

      .notice-content p, .notice-content li, .notice-content ul {
        margin: 0 6%;
        font-size: 15px;
      }

      .notice-content p.update-time {
        margin: 20px 6% 20px 0;
      }

      .ann-swiper-button-next, .ann-swiper-button-prev {
        right: 0;
        width: 23px;
        height: 44px;
        background-size: 23px 44px;
      }

      .ann-swiper-button-next {
        right: 0;
      }

      .ann-swiper-button-prev {
        left: 0;
      }
    }

    @media screen and (max-width: 695px) {
      #app-ann > .notice-banner {
        /*top: 20px;*/
      }
    }

    /* 測試用 */
    .swiper-container { /* height: 700px; */ }

    #app-ann > .notice {
      height: auto;
    }

    .hide {
      visibility: hidden;
    }

    [v-cloak] {
      visibility: hidden;
    }
  `,
});
